import { v4 as uuidv4 } from 'uuid';

export function base64ToFile(base64Image: string, format: string = 'image/jpeg') {
    const byteCharacters = atob(base64Image.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const photoBlob = new Blob([byteArray], { type: format });
    const formData = new FormData();
    if(format === 'image/jpeg') {
      formData.append('file', photoBlob, 'photo.jpg');
    } else {
      formData.append('file', photoBlob, 'photo.png');
    }
    return formData;
}

export function generateId(): string {
  console.log('generateId');
  return uuidv4();
}
